
export default function Testimonials() {
  const testimonials = [
    {
      name: '김민준',
      school: '서울 강남고등학교 2학년',
      content: '철학 공부를 통해 정말 많은 것을 깨달았어요. 매주 받는 자료가 너무 유익하고, 생각하는 힘이 많이 늘었습니다. 특히 리더십에 대한 새로운 관점을 얻게 되었어요.',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/b81393994f213e6c987b015fccbfa89f.jpg'
    },
    {
      name: '이서연',
      school: '부산 해운대중학교 3학년',
      content: '처음에는 철학이 어려울 줄 알았는데, 쉽고 재미있게 설명해주셔서 금방 이해할 수 있었어요. 행복에 대해 다시 생각해보게 되었고, 가족의 소중함도 더 느끼게 되었습니다.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Cheerful%20Korean%20middle%20school%20female%20student%20with%20bright%20smile%2C%20portrait%20style%2C%20educational%20atmosphere&width=100&height=100&seq=student2&orientation=squarish'
    },
    {
      name: '박준호',
      school: '대구 수성고등학교 1학년',
      content: '매주 오는 자료를 읽으면서 정말 많은 지혜를 얻고 있어요. 친구들과도 철학적인 대화를 나누게 되었고, 학교에서도 리더 역할을 맡게 되었습니다. 정말 추천해요!',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Confident%20Korean%20high%20school%20male%20student%20with%20thoughtful%20expression%2C%20portrait%20style%2C%20academic%20background&width=100&height=100&seq=student3&orientation=squarish'
    },
    {
      name: '최유진',
      school: '인천 연수중학교 2학년',
      content: '솔로몬의 지혜를 배우면서 어려운 상황에서도 현명하게 판단할 수 있게 되었어요. 부모님께서도 제가 많이 성숙해졌다고 하시네요. 정말 감사합니다.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Wise%20looking%20Korean%20middle%20school%20female%20student%20with%20gentle%20smile%2C%20portrait%20style%2C%20warm%20educational%20setting&width=100&height=100&seq=student4&orientation=squarish'
    },
    {
      name: '정현우',
      school: '광주 광산고등학교 3학년',
      content: '대학 입시 준비로 스트레스가 많았는데, 철학 공부를 통해 마음의 평안을 찾았어요. 복잡하지 않은 행복의 의미를 깨달으면서 더 여유로워졌습니다.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Peaceful%20Korean%20high%20school%20male%20student%20with%20calm%20expression%2C%20portrait%20style%2C%20serene%20educational%20background&width=100&height=100&seq=student5&orientation=squarish'
    },
    {
      name: '한소희',
      school: '울산 남구중학교 1학년',
      content: '처음 철학을 접했을 때는 어려웠지만, 선생님의 설명이 너무 좋아서 점점 흥미를 갖게 되었어요. 이제는 철학자가 되고 싶다는 꿈도 생겼습니다!',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Enthusiastic%20Korean%20middle%20school%20female%20student%20with%20bright%20eyes%2C%20portrait%20style%2C%20inspiring%20educational%20atmosphere&width=100&height=100&seq=student6&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            학생들의 생생한 후기
          </h2>
          <p className="text-xl text-gray-600">
            철학 공부를 통해 변화된 학생들의 이야기를 들어보세요
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-4">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-bold text-gray-800">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.school}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              
              <p className="text-gray-700 leading-relaxed">
                "{testimonial.content}"
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-800 mb-6">
              놀라운 변화의 통계
            </h3>
            <div className="grid md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-600 mb-2">98%</div>
                <p className="text-gray-600">학생 만족도</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-green-600 mb-2">1,200+</div>
                <p className="text-gray-600">참여 학생 수</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-purple-600 mb-2">85%</div>
                <p className="text-gray-600">리더십 향상</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-orange-600 mb-2">92%</div>
                <p className="text-gray-600">지속 참여율</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
